// src/components/layouts/Footer.tsx
import { Logo } from '@/components/elements';
import { RoobiniumMark } from '@/components/elements';

export const Footer = () => {
    const navLinks = [
        { label: 'Whitepaper', href: '/whitepaper' },
        { label: 'Marketplace', href: '/marketplace' },
        { label: 'Governance', href: '/governance' },
        { label: 'Transparency', href: '/transparency' },
        { label: 'Privacy Policy', href: '/privacy' },
        { label: 'Terms of use', href: '/terms' },
    ];

    return (
        <footer className="w-full bg-neutral rounded-t-[32px] backdrop-blur-md mt-16">
            <div className="max-w-[1200px] mx-auto py-6 lg:py-12 px-4 space-y-4 lg:space-y-6">
                {/* Top Section: Logo + Navigation */}
                <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-4 lg:gap-0">
                    <Logo />
                    
                    {/* Navigation - Grid on mobile, flex on desktop */}
                    <nav className="grid grid-cols-3 gap-y-3 gap-x-4 lg:flex lg:items-center lg:gap-8">
                        {navLinks.map((link) => (
                            <a
                                key={link.href}
                                href={link.href}
                                className="text-white/60 text-sm lg:text-base font-normal font-outfit leading-5 lg:leading-6 hover:text-white transition-colors"
                            >
                                {link.label}
                            </a>
                        ))}
                    </nav>
                </div>

                {/* Divider */}
                <div className="border-t border-white/10" />

                {/* Bottom Section: Copyright + Credits */}
                <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-2 lg:gap-0">
                    <div className="text-white/60 text-sm lg:text-base font-normal font-outfit leading-5 lg:leading-6">
                        © 2025 Crypto Crap. All Rights Reserved
                    </div>
                    <div className="flex items-center gap-2">
                        <span className="text-white/60 text-sm lg:text-base font-normal font-outfit leading-5 lg:leading-6">
                            Design support by
                        </span>
                        <a 
                            href="https://roobinium.io" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="flex items-center gap-1 hover:opacity-80 transition-opacity"
                        >
                            <div className="w-4 h-4">
                                <RoobiniumMark />
                            </div>
                            <span className="text-white/60 text-sm lg:text-base font-normal font-outfit leading-5 lg:leading-6">
                                roobinium.io
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};